import gql from 'graphql-tag';

export default gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      authCode
      image {
        original
        scaled
        thumbnail
        id
      }
      lastName
      email
      password
      status
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetUser.ts